export default {
    account_overview_title: 'Cuenta',
    account_overview_actions: 'Acciones',
    account_overview_username: 'Nombre de Usuario',
    account_overview_opened_at: 'Abierto en',
    account_overview_status: 'Estado',
    account_overview_package: 'Paquete',
    account_overview_devices: 'Dispositivos',
    account_overview_brand: 'Marca',
    account_overview_dealer: 'Distribuidor',
    account_overview_crm: 'Id. de Salesforce',
    account_overview_activities: 'Actividades',
    account_overview_keysfobs: 'Llaves',
    account_overview_user: 'Usuarios',
    account_overview_edit_account: 'Editar Cuenta',
    account_overview_reset_account_password: 'Cambiar la Contraseña',
    account_overview_change_account_status: 'Cambiar el Estado',
    account_overview_change_account_brand: 'Cambiar el Distribuidor',
    account_overview_import_and_assign: 'Importar y Asignar',
    account_overview_device_models: 'Modelos de Dispositivos',
    account_overview_part_numbers: 'Números de Pieza',
    account_overview_unit_types: 'Tipos de Unidades',
    account_overview_active_devices: 'Dispositivos Activos',
    account_overview_system_alert_logs: 'Logs Sistema de Alertas',
    account_overview_scheduled_reports: 'Reportes Programados',
    account_overview_email: 'Correo electrónico',
    account_overview_export_logs: 'Registros de Exportación',
    account_overview_terms_conditions: 'Verificar los términos y condiciones',
    account_overview_scheduled_actions: 'Acciones programadas',
    account_overview_change_username: 'Cambiar el Nombre de Usuario',
    account_overview_promiles_request: 'Solicitud de Promiles',
    account_overview_integrations: 'Integraciones',
    account_overview_warnings: 'Advertencias',
    account_overview_reset_account_email: 'Cambiar el Correo Electrónico',
    account_overview_registration_status: 'Estado de Registro',
    account_overview_resend_invite: 'Reenviar Invitación',
    account_overview_credentials: 'Credenciales',
    account_overview_syncZonar: 'Sincronizar con Zonar',
    account_overview_readonly: 'Solo Lectura',
    account_overview_edge_tensor: 'Revisiones de Video IA',
    account_overview_api_keys: 'Llaves de API',
};